import { Hit, PDFOptions } from "./type";

export function generateQueryParams(options: PDFOptions) {
  const params = new URLSearchParams({
    "summary_params[show_summary]": options.show_summary ? "1" : "0",
    "summary_params[show_details]": options.show_details ? "1" : "0",
    "summary_params[include_forums]": options.include_forums ? "1" : "0",
    "summary_params[include_research]": options.include_research ? "1" : "0",
    "summary_params[include_blogs]": options.include_blogs ? "1" : "0",
    "summary_params[include_transcripts]": options.include_transcripts
      ? "1"
      : "0",
    "summary_params[include_articles]": options.include_articles ? "1" : "0",
    "summary_params[price_charts]": options.price_charts ? "1" : "0",
    "summary_params[score_summary]": options.score_summary ? "1" : "0",
    "summary_params[portfolio_name]": options.portfolio_name,
    "summary_params[period]": options.period,
    "summary_params[summarizer_name]": options.summarizer_name,
  });

  if (options.ticker && options.ticker !== "") {
    params.set("ticker", options.ticker);
  }

  return params.toString();
}

/**
 * Should also create an issue and send an email out from console.sst.dev
 * @param message
 * @param options
 */
export function phgError(message: string, options: ErrorOptions) {
  console.error(new Error(message), options);
}

/**
 * Formats the hit for Ai Api consumption.
 * @param r Hit
 * @returns string | undefined
 */
export function formatHit(r: Hit): string | undefined {
  const title =
    r.highlight.title || r.title
      ? `Title: ${r.highlight.title ?? r.title}\n`
      : undefined;
  const initials = r.user?.initials ? `by: ${r.user.initials}\n` : undefined;
  const itemDate = r.itemDate ? `on Date: ${r.itemDate}\n` : undefined;
  const body = r.highlight.body
    ? `
  ${r.highlight.body.join("\n")}
  `
    : undefined;

  return [title, initials, itemDate, body].filter(Boolean).join("\n");
}
